module.exports = __webpack_public_path__ + "static/media/icon-dashboard-cart.94220786.svg";